import Account from './Account'
import cryptoServices from './crypto'
import edgesServices from './edges'

const services = {
    Account,
    cryptoServices: { ...cryptoServices },
    edgesServices: { ...edgesServices }
}

export default services